import { render, staticRenderFns } from "./LegacyExperimentTargetFields.vue?vue&type=template&id=05dee2d6"
import script from "./LegacyExperimentTargetFields.vue?vue&type=script&lang=js"
export * from "./LegacyExperimentTargetFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports